import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PowerBiDashboardRoutingModule } from './power-bi-dashboard-routing.module';
import { OverdueDebtComponent } from './overdue-debt/overdue-debt.component';

@NgModule({
  imports: [
    CommonModule,
    PowerBiDashboardRoutingModule
  ],
  declarations: [
    OverdueDebtComponent
  ]
})
export class PowerBiDashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/power-bi-dashboard.module.ts